import ThemeCustomization from 'themes';
import MenuInfo from 'data/menu';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import RootRoutes from 'RootRoutes';
import EnumValuesStorage from 'contexts/EnumValuesStorage';
import { ThemeProvider } from 'components/ThemeContext';
import { useTokenRefresh } from 'components/axios/useTokenRefresh';
import { useTranslation } from 'react-i18next';
import { getBrowserTitle } from 'data/data';

export default function App() {
  useTokenRefresh();
  const { t } = useTranslation();
  const hostname = window.location.hostname;
  const location = useLocation();
  const root = MenuInfo.ROOT;
  root.active(location.pathname);

  const setBWTitle = () => {
    document.title = getBrowserTitle(hostname);
    document.querySelector('meta[name="description"]')?.setAttribute('content', getBrowserTitle(hostname))
  };

  setBWTitle();

  useEffect(() => {
    const baseWidth = 1920;
    const minWidth = 1280;

    function applyScale() {
      const winW = window.innerWidth;
      // const scale = winW <= baseWidth ? 1 : Math.max((winW / baseWidth) - 0.01, 1);
      let scale;
      if (winW > baseWidth) {
        // 1920 이상 → 확대
        scale = Math.max((winW / baseWidth) - 0.01, 1);
      } else if (winW > minWidth) {
        // 1280~1920 → 비율 유지하며 축소
        scale = winW / baseWidth;
      } else {
        // 1280 이하 → CSS로 처리, scale 1로 고정
        scale = 1;
      }

      const content = document.querySelector('.monitering');
      if (content) {
        content.style.transform = `scale(${scale})`;
        content.style.left = '0px';
        content.style.top = '0px';
      }
    }

    applyScale();
    window.addEventListener('resize', applyScale);

    return () => {
      window.removeEventListener('resize', applyScale);
    };
  }, []);

  useEffect(() => {
  }, [location])

  if (location.pathname.startsWith('/auth')) {
    return (
      <>
      <ThemeProvider>
        <ThemeCustomization>
            <RootRoutes/>
        </ThemeCustomization>
      </ThemeProvider>
      </>
    );
   } else {
    return (
      <>
        <ThemeProvider>
          <ThemeCustomization>
            <EnumValuesStorage>
              <RootRoutes/>
            </EnumValuesStorage>
          </ThemeCustomization>
        </ThemeProvider>
      </>
    )
  }
}